export const polyfillGetDisplayMedia = () => {
  // Polyfill is not supported
  if (!window?.navigator?.mediaDevices?.getDisplayMedia) {
    return
  }

  window.navigator.mediaDevices.getDisplayMedia = () => {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        const sources = await window.api.getDisplaySources()
        const missingSources = sources.filter(({ thumbnail }) => {
          return !thumbnail || thumbnail === 'data:image/png;base64,'
        })
        const selectionElem = document.createElement('section')
        selectionElem.classList = 'desktop-capturer-selection'
        selectionElem.innerHTML = `
          <div class="desktop-capturer-selection__scroller">
            ${missingSources.length > 0 ? "<h2 class='desktop-capturer-selection__header'>Please enable screen sharing permissions in your computer's privacy settings</h2>" : ''}
            <ul class="desktop-capturer-selection__list">
              ${sources
                .filter(({ thumbnail }) => {
                  return !!thumbnail && thumbnail !== 'data:image/png;base64,'
                })
                .map(
                  ({ id, name, thumbnail, display_id, appIcon }) => {
                    let iconImg = ''
                    if (appIcon) {
                      iconImg = `<img width="20" height="20" class="desktop-capturer-selection__icon" src="${appIcon}" />`
                    }
                    return `
                <li class="desktop-capturer-selection__item">
                  <button class="desktop-capturer-selection__btn" data-id="${id}" title="${name}">
                    <img class="desktop-capturer-selection__thumbnail" src="${thumbnail}" />
                    <div class="desktop-capturer-selection__name">${iconImg} <span>${name}</span></div>
                  </button>
                </li>
              `
                  })
                .join('')}
            </ul>
          </div>
        `
        document.body.appendChild(selectionElem)

        // When the backdrop is clicked, remove the element
        const backdrop = document.querySelector('.desktop-capturer-selection')
        backdrop.addEventListener('click', () => {
          resolve(undefined)
          selectionElem.remove()
        })

        document
          .querySelectorAll('.desktop-capturer-selection__btn')
          .forEach((button) => {
            button.addEventListener('click', async (e) => {
              e.stopPropagation()
              e.preventDefault()
              try {
                const id = button.getAttribute('data-id')
                const source = sources.find((source) => source.id === id)
                if (!source) {
                  throw new Error(`Source with id ${id} does not exist`)
                }

                const stream = await window.navigator.mediaDevices.getUserMedia(
                  {
                    audio: false,
                    video: {
                      mandatory: {
                        chromeMediaSource: 'desktop',
                        chromeMediaSourceId: source.id,
                      },
                    },
                  },
                )
                resolve(stream)

                selectionElem.remove()
              } catch (err) {
                console.error('Error selecting desktop capture source:', err)
                reject(err)
              }
            })
          })
      } catch (err) {
        console.error('Error displaying desktop capture sources:', err)
        reject(err)
      }
    })
  }
}
